import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { ComponentSync, EditableItem, LL_H_C, ModuleFE_MouseInteractivity, TS_Input } from '@nu-art/thunderstorm-frontend';
import { createRef } from 'react';
import { ModuleFE_WorkHub } from '../../../../_module/index.js';
import { BadImplementationException, compare } from '@nu-art/ts-common';
import './Component_WorkHub_TabGroupMenu.scss';
import { workHubTabGroupColors } from '../Component_WorkHub_TabGroup/consts.js';
export class Component_WorkHub_TabGroupMenu extends ComponentSync {
    inputRef = createRef();
    // ######################## Static ########################
    static show = (e, groupKey) => {
        const group = ModuleFE_WorkHub.group.get(groupKey);
        if (!group)
            throw new BadImplementationException(`Did not find group for key ${groupKey}`);
        const rect = e.currentTarget.getBoundingClientRect();
        const model = {
            id: 'pop-up__work-hub-tab-group-menu',
            modalPos: { x: 1, y: 1 },
            originPos: { x: rect.x, y: rect.bottom },
            offset: { y: 4 },
            content: () => _jsx(Component_WorkHub_TabGroupMenu, { group: group }),
        };
        ModuleFE_MouseInteractivity.showContent(model);
    };
    // ######################## Life Cycle ########################
    deriveStateFromProps(nextProps, state) {
        state.group = this.getEditable(nextProps.group);
        return state;
    }
    componentDidMount() {
        this.inputRef.current?.focus();
    }
    componentDidUpdate() {
        this.inputRef.current?.focus();
    }
    // ######################## Logic ########################
    getEditable(group) {
        return new EditableItem(group)
            .setOnChanged(async () => this.forceUpdate())
            .setSaveAction(async (group) => {
            ModuleFE_WorkHub.group.update(group.groupKey, group);
            return group;
        })
            .setAutoSave(true);
    }
    // ######################## Render ########################
    render() {
        return _jsxs(_Fragment, { children: [this.render_Label(), this.render_Color()] });
    }
    render_Label = () => {
        return _jsx(TS_Input, { type: 'text', value: this.state.group.item.label, onChange: value => this.state.group.updateObj({ label: value }), innerRef: this.inputRef });
    };
    render_Color = () => {
        return _jsx(LL_H_C, { className: 'color-selection', children: workHubTabGroupColors.map((scheme, index) => {
                const style = { '--color': scheme.foreground };
                const selected = compare(scheme, this.state.group.item.color);
                return _jsx("div", { className: selected ? 'selected' : undefined, style: style, onClick: () => {
                        this.state.group.updateObj({ color: scheme });
                    } }, index);
            }) });
    };
}
//# sourceMappingURL=Component_WorkHub_TabGroupMenu.js.map